export function buildMap<TK, TV>(keys: TK[], map: (k: TK) => TV): Map<TK, TV> {
  const entries = keys.map(k => [k, map(k)] as [TK, TV]);
  return new Map<TK, TV>(entries);
}
